import { Vue, Component } from "vue-property-decorator";
import MultiSelectBroadcaster, {
  Agency,
} from "@/models/MultiSelectBroadcaster";
import { API_ENDPOINT } from "@/constants";
import axios from "axios";
import { Getter } from "vuex-class";
import AdcontrolProfile from "@/models/AdcontrolProfile";

type CompetingBroadcasterResult = {
  broadcasters: MultiSelectBroadcaster[];
  agencies: Agency[];
};

@Component({})
export default class ReportBroadcasterMixin extends Vue {
  @Getter("profile") mixinProfile!: AdcontrolProfile;

  getBroadcasters(
    type: string,
    startsAt: string,
    endsAt: string
  ): Promise<CompetingBroadcasterResult> {
    const url =
      API_ENDPOINT +
      `/${this.mixinProfile.slug}/${type}/competing_broadcasters.json?starts_at=${startsAt}&ends_at=${endsAt}`;
    return axios(url).then((res) => this.parseBroadcasters(res.data.data));
  }

  getTemplateBroadcasters(type: string): Promise<CompetingBroadcasterResult> {
    const url =
      API_ENDPOINT +
      `/${this.mixinProfile.slug}/${type}/competing_broadcasters/template_options.json`;
    return axios(url).then((res) => this.parseBroadcasters(res.data.data));
  }

  parseBroadcasters(
    data: MultiSelectBroadcaster[]
  ): CompetingBroadcasterResult {
    const map = new Map();

    for (const element of data) {
      let broadcaster = new MultiSelectBroadcaster();

      if (map.has(element.name)) {
        broadcaster = map.get(element.name);
      } else {
        broadcaster = {
          name: element.name,
          ids: new Set(),
          agencies: new Set(),
        };
      }

      const agency = element.advertising_agency;
      if (agency) {
        agency.date = element.ends_at ?? "";

        if (element.id != null) {
          broadcaster.ids?.add(element.id);
        }
        broadcaster.agencies?.add(agency);
      }
      map.set(element.name, broadcaster);
    }

    let broadcasters = [...map.values()];
    const agencies = new Map();

    broadcasters = broadcasters.map((broadcaster) => {
      broadcaster.ids = [...broadcaster.ids];
      broadcaster.id = broadcaster.ids[0];

      broadcaster.agencies = [...broadcaster.agencies];
      broadcaster.agencies.sort((a: Agency, b: Agency) => {
        if (this.$moment(a.date).isBefore(b.date)) {
          return 1;
        } else if (this.$moment(a.date).isAfter(b.date)) {
          return -1;
        } else {
          return 0;
        }
      });

      broadcaster.advertising_agency = broadcaster.agencies.length
        ? broadcaster.agencies[0]
        : null;
      broadcaster.group = broadcaster.advertising_agency
        ? broadcaster.advertising_agency.id
        : null;

      agencies.set(broadcaster.advertising_agency.id, {
        id: broadcaster.advertising_agency.id,
        name: broadcaster.advertising_agency.name,
      });

      return broadcaster;
    });

    return {
      broadcasters,
      agencies: [...agencies.values()],
    };
  }
}
